import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  for: "emailNotifiche",
  class: "field-required"
}
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}

import {ref} from "vue";
import * as valUtil from "@/helper/validationUtils";
import {useUserStore} from "@/stores/user";
import { useServiceDetailStore } from "@/stores/service/serviceDetail";
import enMessages from "@/locales/en.json";
import itMessages from "@/locales/it.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'SetEmail',
  emits: ['close'],
  setup(__props, { emit }) {

const serviceDetailStore = useServiceDetailStore();
const userStore = useUserStore();
const email = ref<string | null>()
const inError = ref<{ [key: string]: string }>({} as { [key: string]: string })



function clearValidation(e: any) {
    valUtil.clearValidation(inError, e)
}

function save() {
    if (valUtil.validationEmail(email.value)) {
        userStore.updateUser(email.value ?? null, null, null).then(() => {
            emit('close')
        })
    } else {
      const language = serviceDetailStore.language || 'en';
      const messages = language === 'it' ? itMessages : enMessages;
        inError.value['emailNotifiche'] = messages.validMailMessage
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('emailMessage')), 1),
      _withDirectives(_createElementVNode("input", {
        type: "email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        class: "form-control",
        id: "emailNotifiche",
        onInput: clearValidation
      }, null, 544), [
        [_vModelText, email.value]
      ]),
      (inError.value['emailNotifiche'])
        ? (_openBlock(), _createElementBlock("sub", _hoisted_4, _toDisplayString(inError.value['emailNotifiche']), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      onClick: save,
      class: "btn btn-success mt-3",
      "data-focus-mouse": "false"
    }, _toDisplayString(_ctx.$t('save')), 1)
  ]))
}
}

})